import { Controller } from "@hotwired/stimulus"
import { getRecaptchaToken } from "../lib/recaptcha"

export default class extends Controller {
  static targets = [
    "formState", "successState", "emailInput", "successEmail", "errorMessage",
    "productInput", "submitBtn", "productCard",
    "productHint", "productSelectedDisplay", "productSelectedName"
  ]
  static values = { recaptchaSiteKey: String }

  selectProduct(event) {
    const card = event.currentTarget
    const product = card.dataset.product
    const productName = card.dataset.productName

    // Update hidden input
    this.productInputTarget.value = product

    // Reset all cards then highlight the selected one
    this.productCardTargets.forEach(c => {
      c.classList.remove('is-selected')
      const cta = c.querySelector('.ge-signup__card-cta')
      if (cta) cta.textContent = 'Select'
    })
    card.classList.add('is-selected')
    const cta = card.querySelector('.ge-signup__card-cta')
    if (cta) cta.textContent = '✓ Selected'

    // Show the selected tool in the form card
    this.productHintTarget.style.display = 'none'
    this.productSelectedDisplayTarget.style.display = ''
    this.productSelectedNameTarget.textContent = productName

    // Enable submit and focus email
    this.submitBtnTarget.disabled = false
    this.emailInputTarget.focus()
  }

  clearProduct(event) {
    event.preventDefault()

    // Reset hidden input and button
    this.productInputTarget.value = ''
    this.submitBtnTarget.disabled = true

    // Reset all cards
    this.productCardTargets.forEach(c => {
      c.classList.remove('is-selected')
      const cta = c.querySelector('.ge-signup__card-cta')
      if (cta) cta.textContent = 'Select'
    })

    // Restore the hint in the form card
    this.productSelectedDisplayTarget.style.display = 'none'
    this.productSelectedNameTarget.textContent = ''
    this.productHintTarget.style.display = ''

    // Scroll product cards into view
    this.productCardTargets[0]?.closest('.ge-signup__section')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  async submit(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value
    if (!email) return

    this._clearError()
    const form = event.target
    const formData = new FormData(form)

    const token = await this._getRecaptchaToken()
    if (token) formData.append('g-recaptcha-response', token)

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.successEmailTarget.textContent = `We've sent a link to ${email}`
        this.formStateTarget.style.display = 'none'
        this.successStateTarget.style.display = ''
      } else {
        const data = await response.json()
        this._showError(data.error || 'Something went wrong')
      }
    } catch {
      this._showError('Network error. Please try again.')
    }
  }

  resend(event) {
    event.preventDefault()
    const form = this.formStateTarget.querySelector('form')
    if (!form) return
    const formData = new FormData(form)
    this._getRecaptchaToken().then(token => {
      if (token) formData.append('g-recaptcha-response', token)
      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })
    })
  }

  _showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.style.display = ''
    }
  }

  _clearError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = ''
      this.errorMessageTarget.style.display = 'none'
    }
  }

  _getRecaptchaToken() {
    return getRecaptchaToken(this.recaptchaSiteKeyValue, 'signup')
  }
}
